<template>

    <cart-widget-base>
        <template slot-scope="{ items, discounts, price, isOpen }">
            <div
                v-if="isOpen"
                class="card cart-widget"
            >

                <div class="cart-content">
                <button class="cart-close" @click="toggl()">
                    <svg class="icon" :aria-label="__('Kosár ablak bezárása')">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                             xlink:href="#icon-cart-close"></use>
                    </svg>
                </button>

                <div class="card-body cart-widget-items">

                    <ul class="cart-list">
                        <cart-widget-item
                            v-for="item in items"
                            :key="item.id.identifier"
                            :item="item"
                        />
                    </ul>
                    <div
                        v-if="discounts.length"
                        class="cart-discounts"
                    >
                        <p class="card-subtitle">
                            {{ __('Kedvezmények') }}
                        </p>
                        <component
                            :is="discount.type"
                            v-for="(discount, key) in discounts"
                            :key="key"
                            :discount="discount"
                        />
                    </div>
                </div>
                <div class=" card cart-widget-summary cart-footer">
                    <span class="cart-text">{{ __('Összesen') }}:</span>
                    <span class="cart-total">{{ formatNegativePrice(price.gross) | currency(currencyFormat(currencyValue)) }}</span>
                    <span class="cart-continue" @click="toggl()">{{ __('Tovább vásárolok') }} »</span>
                    <a
                        :href="route('shop.checkout.show')"
                        class="cart-button text-uppercase"
                    >
                        {{ __('Pénztár') }}
                    </a>
                </div>

                </div>
            </div>
        </template>
    </cart-widget-base>
</template>

<script>
import currencyFormatter from '../../mixins/currencyFormatter';

export default {
    mixins: [currencyFormatter],

    methods: {
        toggl() {
            this.$bus.$emit('cart-widget-toggled')
        }
    },

    props: {
        currencyValue: {
            type: String,
            required: true
        }
    }

}
</script>
